import { UploadIcon } from '@heroicons/react/solid';
import { Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import moment from 'moment';
import warning from '../../../features/dossierIncapacite/assets/warning.svg';

const useStyles = makeStyles(() => ({
    accordion: {
        border: 'none',
        boxShadow: 'none',
    },
    summary: {
        backgroundColor: '#3399DB',
        height: '54px',
        padding: 0,
        paddingRight: '15px',
        '&.Mui-expanded': {
            minHeight: '54px',
        },
    },
    summaryContent: {
        margin: '0',
    },
    details: {
        padding: '0',
    },
    header: {
        height: '54px',
    },
    dtEmis: {
        color: '#fff',
        fontSize: '0.8rem',
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        height: '100%',
        width: '170px',
    },
    amount: {
        color: '#fff',
        fontSize: '1.2rem',
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        background: '#2574A9',
        borderLeft: '1px solid #fff',
        borderRight: '1px solid #fff',
        height: '100%',
        minWidth: '170px',
    },
    destinataire: {
        color: '#fff',
        fontSize: '1rem',
        fontFamily: 'Open Sans',
        fontStyle: 'italic',
        height: '100%',
        minWidth: '170px',
        padding: '10px',
    },
    centeredText: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    txtGreen: {
        color: '#2574A9',
        fontSize: '0.83rem ',
        fontFamily: 'Open Sans ',
        fontStyle: 'normal ',
        fontWeight: 700,
    },
    txtBlue: {
        color: '#2574a9',
        fontSize: '0.83rem ',
        fontFamily: 'Open Sans ',
        fontStyle: 'normal ',
        fontWeight: 700,
    },
    tableHeader: {
        background: '#F5F5F5',
    },
}));

const StyledTableRow = styled(TableRow)(() => ({
    backgroundColor: '#E1F1FC',
    borderBottom: 'none',
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
}));

const StyledTableCell1 = styled(TableCell)(() => ({
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontSize: '0.85rem',
    textAlign: 'center',
    borderRight: '1px solid #cdcdcd',
    borderBottom: '1px solid #cdcdcd',
    borderTop: 'none',
    '&:last-child': {
        borderRight: 'none', // Remove the right border for the last cell
    },
}));

const StyledTableCell = styled(TableCell)(() => ({
    color: '#4F7793',
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontSize: '0.85rem',
    textAlign: 'left',
    verticalAlign: 'top',
    paddingTop: '5px',
    height: '54px',
    paddingBottom: '3px',
    borderBottom: 'none',
    borderRight: '1px solid #cdcdcd',
    borderTop: '1px solid #cdcdcd',
}));

const StyledTableContainer = styled(TableContainer)(() => ({
    boxShadow: 'none',
    border: '1px solid #3ba7ca',
}));

type Document = {
    nom: string;
    dtReception: string;
    statut: string;
    commentaire?: string;
};

type Props = {
    documents: Document[];
};

const DocumentsTable: React.FC<Props> = ({ documents }) => {
    const classes = useStyles();
    return (
        <StyledTableContainer>
            <Table>
                <TableHead>
                    <StyledTableRow>
                        <TableCell colSpan={6} align="center">
                            <Typography className={classes.txtGreen}>DOCUMENTS</Typography>
                        </TableCell>
                    </StyledTableRow>
                    <TableRow className={classes.tableHeader}>
                        <StyledTableCell1>
                            <Typography className={classes.txtGreen}>Nom du document</Typography>
                        </StyledTableCell1>
                        <StyledTableCell1>
                            <Typography className={classes.txtGreen}>Commentaire</Typography>
                        </StyledTableCell1>
                        <StyledTableCell1>
                            <Typography className={classes.txtGreen}>Statut</Typography>
                        </StyledTableCell1>
                        <StyledTableCell1>
                            <Typography className={classes.txtGreen}>Action</Typography>
                        </StyledTableCell1>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {documents &&
                        documents.map((d) => {
                            return (
                                <TableRow className="detail">
                                    <StyledTableCell style={{ textTransform: 'uppercase' }}>
                                        <>{d.nom}</>
                                    </StyledTableCell>
                                    <StyledTableCell>{d.commentaire}</StyledTableCell>
                                    <StyledTableCell className="text-center">
                                        {d.dtReception !== ''
                                            ? `Reçu le ${moment(d.dtReception, 'YYYY-MM-DD').format('DD/MM/YYYY')}`
                                            : d.statut === 'En attente' && (
                                                  <>
                                                      <img src={warning} alt="Warning Icon" width={'20px'} />
                                                      <span style={{ paddingLeft: '10px', textTransform: 'uppercase' }}>{d.statut}</span>
                                                  </>
                                              )}
                                    </StyledTableCell>
                                    <StyledTableCell className="text-center">
                                        <Typography className={classes.txtGreen}>
                                            <Button variant="outlined" style={{ minWidth: '20px', background: '#2574a9', color: '#fff' }}>
                                                <UploadIcon width={'20px'} />
                                            </Button>
                                        </Typography>
                                    </StyledTableCell>
                                </TableRow>
                            );
                        })}
                </TableBody>
            </Table>
        </StyledTableContainer>
    );
};

export default DocumentsTable;
